import type {FC} from 'react';

import type {ChannelApiModel} from '../../api/channel';

import {createChannel} from '../../services/entity-action/channel/channel.create';
import {isUserHasRole} from '../../utils/entity/user';
import {envManager} from '../../utils/env';
import {logger} from '../../utils/logger';
import {TestID} from '../../utils/test-utils/data-test-id';
import {alert} from '../alert';
import {SupportChatButtonJSX} from './components/SupportChatButtonJSX';

type Props = {
  onClick: (channel: ChannelApiModel) => void;
};

export const SupportChatButton: FC<Props> = ({onClick}: Props) => {
  const handleCreateSupportChat = async () => {
    try {
      const channel = await createChannel({channel_type: 'support'});

      onClick(channel);
    } catch (error) {
      logger.error(error);
      alert.error(error);
    }
  };

  if (isUserHasRole('support') || envManager.isB2b) {
    return null;
  }

  return (
    <SupportChatButtonJSX
      onClick={handleCreateSupportChat}
      testID={TestID.menu.button.support}
    />
  );
};
